import {css, StyleSheet} from 'aphrodite';
import React from 'react';

import {assert} from 'Asserts';
import {SequencePrime} from 'biojs/BioConstants';
import {GRAY_DARKER, NEAR_BLACK} from 'ui-library/Colors';
import {EllipsisDirection, ellipsize} from 'util/NameUtil';

import {COLUMN_TYPE, ColumnTransform, SampleDataProps} from '../SpreadsheetBulkImportConstants';

const DISPLAY_LENGTH = 23;

export default function TerminalProbesSampleData(props: SampleDataProps): JSX.Element {
  const prime = props.columnTransform === ColumnTransform.IDT_3MOD ? SequencePrime.THREE : SequencePrime.FIVE;
  const originalValue =
    props.originalValues[COLUMN_TYPE.CUSTOM_MOD_SYNTAX] ?? props.originalValues[COLUMN_TYPE.IDT];
  assert(originalValue !== undefined, 'Expected to find IDT or Custom Notation column in original values');
  const truncatedOriginalString = ellipsize(
    originalValue,
    DISPLAY_LENGTH,
    prime === SequencePrime.FIVE ? EllipsisDirection.BACK : EllipsisDirection.FRONT
  );
  const probePosition = truncatedOriginalString.indexOf(props.derivedValue);
  assert(probePosition !== -1, 'Terminal probe not found in original string.');
  return (
    <p className={css(styles.paragraph)}>
      <span className={css(styles.derivedValue)}>{props.derivedValue}</span>
      {` from "${truncatedOriginalString.slice(0, probePosition)}`}
      <span className={css(styles.highlight)}>{props.derivedValue}</span>
      {`${truncatedOriginalString.slice(
        probePosition + props.derivedValue.length,
        truncatedOriginalString.length
      )}"`}
    </p>
  );
}

const styles = StyleSheet.create({
  derivedValue: {
    color: NEAR_BLACK,
    fontWeight: 'bold',
  },
  highlight: {
    background: 'rgba(235, 135, 21, 0.2)',
  },
  paragraph: {
    color: GRAY_DARKER,
  },
});
